export default __webpack_public_path__ + "static/media/promocionAlarma3.22d57932.png";